"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertInitialSelections = void 0;

var convertInitialSelections = function convertInitialSelections(initialSelections) {
  if (initialSelections) {
    var v2InitialSelections = {};

    for (var i = 0; initialSelections && i < initialSelections.length; i++) {
      var key = initialSelections[i].key;
      var isHidden = !initialSelections[i].isDisplayed;
      v2InitialSelections[key] = {
        isHidden: isHidden,
        initialSelection: initialSelections[i] ? initialSelections[i].resolvedValue : null
      };
    }

    return v2InitialSelections;
  }

  return {};
};

exports.convertInitialSelections = convertInitialSelections;